module.exports = __webpack_public_path__ + "static/media/document.baff588a.svg";